import {
  clamp_exports,
  formatMuiErrorMessage_exports,
  init_clamp,
  init_formatMuiErrorMessage
} from "./chunk-QR3JAPKL.js";
import {
  __commonJS,
  __toCommonJS,
  __toESM
} from "./chunk-PLDDJCW6.js";

// ../../node_modules/@babel/runtime/helpers/interopRequireDefault.js
var require_interopRequireDefault = __commonJS({
  "../../node_modules/@babel/runtime/helpers/interopRequireDefault.js"(exports, module) {
    "use strict";
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }
});

// ../../node_modules/@mui/system/colorManipulator.js
var require_colorManipulator = __commonJS({
  "../../node_modules/@mui/system/colorManipulator.js"(exports) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.alpha = alpha;
    exports.blend = blend;
    exports.colorChannel = void 0;
    exports.darken = darken;
    exports.decomposeColor = decomposeColor;
    exports.emphasize = emphasize;
    exports.getContrastRatio = getContrastRatio2;
    exports.getLuminance = getLuminance;
    exports.hexToRgb = hexToRgb;
    exports.hslToRgb = hslToRgb;
    exports.lighten = lighten;
    exports.private_safeAlpha = private_safeAlpha;
    exports.private_safeColorChannel = void 0;
    exports.private_safeDarken = private_safeDarken;
    exports.private_safeEmphasize = private_safeEmphasize;
    exports.private_safeLighten = private_safeLighten;
    exports.recomposeColor = recomposeColor;
    exports.rgbToHex = rgbToHex;
    var _formatMuiErrorMessage2 = _interopRequireDefault((init_formatMuiErrorMessage(), __toCommonJS(formatMuiErrorMessage_exports)));
    var _clamp = _interopRequireDefault((init_clamp(), __toCommonJS(clamp_exports)));
    function clampWrapper(value, min = 0, max = 1) {
      if (process.env.NODE_ENV !== "production") {
        if (value < min || value > max) {
          console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
        }
      }
      return (0, _clamp.default)(value, min, max);
    }
    function hexToRgb(color) {
      color = color.slice(1);
      const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
      let colors = color.match(re);
      if (colors && colors[0].length === 1) {
        colors = colors.map((n) => n + n);
      }
      return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index) => {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
      }).join(", ")})` : "";
    }
    function intToHex(int) {
      const hex = int.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    }
    function decomposeColor(color) {
      if (color.type) {
        return color;
      }
      if (color.charAt(0) === "#") {
        return decomposeColor(hexToRgb(color));
      }
      const marker = color.indexOf("(");
      const type = color.substring(0, marker);
      if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type) === -1) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, color));
      }
      let values = color.substring(marker + 1, color.length - 1);
      let colorSpace;
      if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") {
          values[3] = values[3].slice(1);
        }
        if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(colorSpace) === -1) {
          throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, colorSpace));
        }
      } else {
        values = values.split(",");
      }
      values = values.map((value) => parseFloat(value));
      return {
        type,
        values,
        colorSpace
      };
    }
    var colorChannel = (color) => {
      const decomposedColor = decomposeColor(color);
      return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
    };
    exports.colorChannel = colorChannel;
    var private_safeColorChannel = (color, warning) => {
      try {
        return colorChannel(color);
      } catch (error) {
        if (warning && process.env.NODE_ENV !== "production") {
          console.warn(warning);
        }
        return color;
      }
    };
    exports.private_safeColorChannel = private_safeColorChannel;
    function recomposeColor(color) {
      const {
        type,
        colorSpace
      } = color;
      let {
        values
      } = color;
      if (type.indexOf("rgb") !== -1) {
        values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
      } else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
      }
      if (type.indexOf("color") !== -1) {
        values = `${colorSpace} ${values.join(" ")}`;
      } else {
        values = `${values.join(", ")}`;
      }
      return `${type}(${values})`;
    }
    function rgbToHex(color) {
      if (color.indexOf("#") === 0) {
        return color;
      }
      const {
        values
      } = decomposeColor(color);
      return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
    }
    function hslToRgb(color) {
      color = decomposeColor(color);
      const {
        values
      } = color;
      const h = values[0];
      const s = values[1] / 100;
      const l = values[2] / 100;
      const a = s * Math.min(l, 1 - l);
      const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      let type = "rgb";
      const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
      if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
      }
      return recomposeColor({
        type,
        values: rgb
      });
    }
    function getLuminance(color) {
      color = decomposeColor(color);
      let rgb = color.type === "hsl" || color.type === "hsla" ? decomposeColor(hslToRgb(color)).values : color.values;
      rgb = rgb.map((val) => {
        if (color.type !== "color") {
          val /= 255;
        }
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
      });
      return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
    }
    function getContrastRatio2(foreground, background) {
      const lumA = getLuminance(foreground);
      const lumB = getLuminance(background);
      return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
    }
    function alpha(color, value) {
      color = decomposeColor(color);
      value = clampWrapper(value);
      if (color.type === "rgb" || color.type === "hsl") {
        color.type += "a";
      }
      if (color.type === "color") {
        color.values[3] = `/${value}`;
      } else {
        color.values[3] = value;
      }
      return recomposeColor(color);
    }
    function private_safeAlpha(color, value, warning) {
      try {
        return alpha(color, value);
      } catch (error) {
        if (warning && process.env.NODE_ENV !== "production") {
          console.warn(warning);
        }
        return color;
      }
    }
    function darken(color, coefficient) {
      color = decomposeColor(color);
      coefficient = clampWrapper(coefficient);
      if (color.type.indexOf("hsl") !== -1) {
        color.values[2] *= 1 - coefficient;
      } else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) {
        for (let i = 0; i < 3; i += 1) {
          color.values[i] *= 1 - coefficient;
        }
      }
      return recomposeColor(color);
    }
    function private_safeDarken(color, coefficient, warning) {
      try {
        return darken(color, coefficient);
      } catch (error) {
        if (warning && process.env.NODE_ENV !== "production") {
          console.warn(warning);
        }
        return color;
      }
    }
    function lighten(color, coefficient) {
      color = decomposeColor(color);
      coefficient = clampWrapper(coefficient);
      if (color.type.indexOf("hsl") !== -1) {
        color.values[2] += (100 - color.values[2]) * coefficient;
      } else if (color.type.indexOf("rgb") !== -1) {
        for (let i = 0; i < 3; i += 1) {
          color.values[i] += (255 - color.values[i]) * coefficient;
        }
      } else if (color.type.indexOf("color") !== -1) {
        for (let i = 0; i < 3; i += 1) {
          color.values[i] += (1 - color.values[i]) * coefficient;
        }
      }
      return recomposeColor(color);
    }
    function private_safeLighten(color, coefficient, warning) {
      try {
        return lighten(color, coefficient);
      } catch (error) {
        if (warning && process.env.NODE_ENV !== "production") {
          console.warn(warning);
        }
        return color;
      }
    }
    function emphasize(color, coefficient = 0.15) {
      return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
    }
    function private_safeEmphasize(color, coefficient, warning) {
      try {
        return private_safeEmphasize(color, coefficient);
      } catch (error) {
        if (warning && process.env.NODE_ENV !== "production") {
          console.warn(warning);
        }
        return color;
      }
    }
    function blend(background, overlay, opacity, gamma = 1) {
      const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
      const backgroundColor = decomposeColor(background);
      const overlayColor = decomposeColor(overlay);
      const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
      return recomposeColor({
        type: "rgb",
        values: rgb
      });
    }
  }
});

// src/theme/theme-utils.ts
var import_colorManipulator = __toESM(require_colorManipulator(), 1);
import varnishTokens from "@allenai/varnish-theme/mui";
var getTypographyStyle = (theme, key, includeKey = true) => {
  return `
    ${includeKey ? `${key} {` : ""}
      color: ${theme.typography[key].color};
      font-family: ${theme.typography[key].fontFamily};
      font-weight:  ${theme.typography[key].fontWeight};
      font-size:  ${theme.typography[key].fontSize};
      line-height:  ${theme.typography[key].lineHeight};
      margin:  ${theme.typography[key].margin};
    ${includeKey ? "}" : ""}
  `;
};
var getThemeObjectTokens = (themeObject, properties = Object.keys(themeObject)) => {
  return properties.reduce((acc, attribute) => {
    acc[attribute] = themeObject[attribute].value.toString();
    return acc;
  }, {});
};
var getColorWithContrastRatio = (baseColor, color) => {
  return {
    color,
    contrastRatio: (0, import_colorManipulator.getContrastRatio)(baseColor, color)
  };
};
var getContrastText = (backgroundColor, mode = "light", desiredContrastRatio = 4.5) => {
  const primaryText = getColorWithContrastRatio(
    backgroundColor,
    varnishTokens.palette[mode].text.primary.default.value
  );
  const reversedText = getColorWithContrastRatio(
    backgroundColor,
    varnishTokens.palette[mode].text.primary.reversed.value
  );
  const secondaryText = getColorWithContrastRatio(
    backgroundColor,
    varnishTokens.palette[mode].text.secondary.default.value
  );
  if (primaryText.contrastRatio >= desiredContrastRatio) {
    return primaryText.color;
  }
  const colorsOrderedByContrastRatio = [primaryText, reversedText, secondaryText].sort(
    (a, b) => b.contrastRatio - a.contrastRatio
  );
  return colorsOrderedByContrastRatio[0].color;
};
var getBetaPaletteTokens = (color, mode = "light") => {
  return {
    main: color.value,
    contrastText: getContrastText(color.value, mode)
  };
};

export {
  getTypographyStyle,
  getThemeObjectTokens,
  getContrastText,
  getBetaPaletteTokens
};
//# sourceMappingURL=chunk-6AMA4GNY.js.map